import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';

const SelectMultiSearch = ({
  options,
  nameInput,
  isDisabled,
  isLoading,
  value,
  setValue,
  placeholder,
  useCheckboxes,
  styles
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (Array.isArray(options)) {
      const updatedOptions = options.filter(option => value.includes(option.value));
      setSelectedOptions(updatedOptions);
    }
  }, [value, options]);

  const updateFormField = (items) => {
    const values = items ? items.map(item => item.value) : [];
    setValue && setValue(nameInput, values);
  };

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    updateFormField(selected);
  };

  return (
    <div>
      <Select
        className="basic-single w-100 input-field"
        classNamePrefix="select"
        placeholder={placeholder ? placeholder : 'Seleccione'}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={false}
        isSearchable={true}
        isMulti
        name={nameInput}
        options={Array.isArray(options) ? options : []}
        value={selectedOptions}
        onChange={handleChange}
        styles={styles}
        components={useCheckboxes ? { Option: (props) => (
          <components.Option {...props}>
            <input
              type="checkbox"
              checked={props.isSelected}
              onChange={() => null}
            />{" "}
            <label>{props.label}</label>
          </components.Option>
        ) } : undefined}
      />
    </div>
  );
};

export default SelectMultiSearch;